



























































import { LessonDTO } from "../../../../src_server/entity/dto/LessonDTO";
import CommonDialog from "../../../components/organisms/CommonDialog.vue";
import { LessonServiceFront } from "../../../biz/LessonServiceFront";
import TransferButton from "../../../components/button/TransferButton.vue";
import CancelButton from "../../../components/button/CancelButton.vue";
import ReportButton from "../ui/ReportButton.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import { LessonStates } from "../../../../src_server/entity/master/LessonStates";
import EmergencyMessageDialog from "../../../components/messages/EmergencyMessageDialog.vue";
import { routeHelper } from "../../../utils/routeHelper";

@Component({
  components: {
    CommonDialog,
    TransferButton,
    CancelButton,
    ReportButton,
    EmergencyMessageDialog,
  },
})
export default class DaEventDetailDialog extends Vue {
  private dto = new LessonDTO();

  get title() {
    return `${this.dto.teacher?.nickname} 詳細`;
  }

  get schoolYear() {
    return this.dto.teacher?.target_school_year;
  }
  get weekDay() {
    return this.dto.teacher?.work_day_of_week;
  }
  get image() {
    return this.dto.teacher?.img_path;
  }

  get contents() {
    return this.dto.da_teacher?.contents;
  }

  get isTransfer() {
    return this.dto.lessons.reservation_state === LessonStates.TRANSFAR;
  }
  get isAlready() {
    return this.dto.lessons.reservation_state === LessonStates.ALREADY;
  }

  async cancel(class_id: number) {
    const biz = new LessonServiceFront();
    await biz.cancel(class_id, (ret_class_id) => {
      this.$emit("delete-lesson", ret_class_id);
    });
  }

  emergencyMessage(dto: LessonDTO) {
    const dialog: EmergencyMessageDialog = this.$refs[
      "emergency_message_dialog"
    ] as EmergencyMessageDialog;
    dialog.show(dto.lessons.class_id!);
  }

  async report(class_id: number) {
    routeHelper(this, "DaStudentDailyReportPage", { class_id: class_id.toString() });
  }

  public async show(dto: LessonDTO) {
    this.dto = dto;
    (this.$refs["da_event_detail_dialog"] as CommonDialog).show();
  }

  public close() {
    (this.$refs["da_event_detail_dialog"] as CommonDialog).hide();
  }
}
